import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  trainingSetGroupsWrapper: {
    '& > div': {
      marginTop: theme.spacing(2),
    },
  },

  timerContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
  },

  headerWrapper: {},
  startTimerButton: {
    position: 'absolute',
    bottom: theme.spacing(6),
    left: theme.spacing(2),
    backgroundColor: `${theme.palette.primary.main} !important`,
    boxShadow: '0px 4px 10px 0px #00000040',
    borderRadius: '50%',
    width: theme.spacing(6),
    height: theme.spacing(6),
    minWidth: 'unset',
    opacity: 0,
    transition: 'opacity 0.3s ease-in-out',
    '&:hover': {
      backgroundColor: `${theme.palette.primary.light} !important`,
    },
  },
  startTimerButtonVisible: {
    opacity: 1,
  },
  startTimerButtonNativeFixed: {
    position: 'fixed',
    left: theme.spacing(2),
    bottom: `calc(${theme.spacing(6)} + env(safe-area-inset-bottom, 0px))`,
    zIndex: theme.zIndex.modal + 1,
  },
  trainingTitle: {
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  clockIconWrapper: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    borderRadius: '10px',
    backgroundColor: theme.palette.secondary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& svg': {
      color: theme.palette.font.secondary,
    },
  },
}));
